import React from 'react';
import { observer } from 'mobx-react-lite';
import { ColumnDef, Row } from '@tanstack/react-table';

import { SortableStripboard } from './sortable-stripboard';
import { SelectionProvider } from '../../../core/contexts/selection.context';

import type { Project, ShootingDay, Stripboard } from '../../../app/entities';

export type StripProps = {
  row: Row<any>;
  dayId?: string;
};

type StripboardProps = {
  stripboard: Stripboard;
  columns: ColumnDef<any>[];
  shootingDays: ShootingDay[];
  project: Project;
  stripIds: string[];
  sortableStripIds: string[];
  totalShootingDays: number;
  unscheduledStrips: Stripboard['unscheduledStrips'];
  dayBreakStripIds: string[];
  hideUnscheduledTable?: boolean;
  onUpdateStrip?: (
    stripId: string,
    update: {
      data?: {
        text?: string;
        estimatedTime?: number;
        isHidden?: boolean;
      };
    },
  ) => Promise<void>;
  onResizeColumn?: (propertyId: string, value: number) => void;
  onResortStrips?: (stripIds: string[], newPosition: number) => Promise<void>;
  onReorderColumn?: (propertyId: string, oldIndex: number, newIndex: number) => void;
  onAddShotToShootingDay?: (shootingDay: ShootingDay) => void;
  getStripPosition?: (stripIndex: number) => number | undefined;

  /**
   * Set to true id the table should scroll in the screen,
   * false if it should stay inline
   * default = true
   */
  scroll?: boolean;
};

export const StripboardTable: React.FC<StripboardProps> = observer(
  ({
    columns,
    stripboard,
    shootingDays,
    project,
    stripIds,
    sortableStripIds,
    totalShootingDays,
    unscheduledStrips,
    dayBreakStripIds,
    hideUnscheduledTable,
    onReorderColumn,
    onResizeColumn,
    onResortStrips,
    onUpdateStrip,
    onAddShotToShootingDay,
    getStripPosition,
    scroll,
  }) => {
    return (
      <SelectionProvider items={stripIds} excludedItems={dayBreakStripIds}>
        <SortableStripboard
          stripboard={stripboard}
          columns={columns}
          project={project}
          stripIds={stripIds}
          shootingDays={shootingDays}
          sortableStripIds={sortableStripIds}
          totalShootingDays={totalShootingDays}
          unscheduledStrips={unscheduledStrips}
          hideUnscheduledTable={hideUnscheduledTable}
          onUpdateStrip={onUpdateStrip}
          onResizeColumn={onResizeColumn}
          onResortStrips={onResortStrips}
          onReorderColumn={onReorderColumn}
          getStripPosition={getStripPosition}
          onAddShotToShootingDay={onAddShotToShootingDay}
          scroll={scroll}
        />
      </SelectionProvider>
    );
  },
);
